<template>
  <div class="user-account">
    <MainNav />
    <div class="jumbotron jumbotron-fluid bg-light">
      <div class="container">
        <h1>Report History</h1>
        <p class="lead">Download existing and see pending reports</p>
      </div>
    </div>
    <div class="container my-3">
      <h2>Pending Reports</h2>
      <div v-if="loading" class="py-2 d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div
        v-if="reportCreatedSuccess"
        class="alert alert-success alert-dismissible fade show mt-2 mb-4"
        role="alert"
      >
        Report created successfully! Your PDF report is being processed and will
        be sent to your email within the next 30 minutes.
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="list-group" v-if="inProgressReports.length > 0">
        <div
          class="list-group-item list-group-item-action"
          v-for="report in inProgressReports"
          v-bind:key="report.Id"
        >
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{ report.Name }}</h5>
            <small>Created {{ report.ReportDate | moment("from") }}</small>
          </div>
          <p class="mb-1">{{ report.Description }}</p>
          <small>Reports can take up to 30 minutes to process</small>
        </div>
      </div>

      <div v-if="!loading && inProgressReports.length === 0">
        <p>Reports that are waiting to be processed will show here</p>
      </div>
    </div>
    <div class="container my-3">
      <h2>Reports</h2>
      <div v-if="loading" class="py-2 d-flex justify-content-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div v-if="!loading && reports.length === 0">
        <p>Completed reports will show here</p>
      </div>

      <div class="row">
        <div
          class="col-sm-12 col-md-4 my-2"
          v-for="report in reports"
          v-bind:key="report.Id"
        >
          <div class="card">
            <img
              :src="`${API_URL}/Reports/${user.Id}/${report.Id}/SearchArea.png`"
              class="card-img-top"
              alt="Report serach area image"
            />
            <div class="card-body">
              <h5 class="card-title">{{ report.Name }}</h5>
              <p class="card-text">{{ report.Description }}</p>
              <p class="card-text">
                <small class="text-muted"
                  >Created {{ report.ReportDate | utcToLocalCalendar }}</small
                >
              </p>
              <div class="dropdown">
                <button
                  class="btn btn-primary dropdown-toggle"
                  type="button"
                  id="downloadDropDown"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Download
                </button>
                <div class="dropdown-menu" aria-labelledby="downloadDropDown">
                  <a
                    class="dropdown-item"
                    target="_blank"
                    :href="
                      `${API_URL}/api/Reports/Download/${user.Id}/Report/${
                        report.Id
                      }`
                    "
                    >Report</a
                  >
                  <a
                    class="dropdown-item"
                    target="_blank"
                    :href="
                      `${API_URL}/api/Reports/Download/${user.Id}/Certificate/${
                        report.Id
                      }`
                    "
                    >Certificate</a
                  >
                  <a
                    class="dropdown-item"
                    target="_blank"
                    :href="
                      `${API_URL}/api/Reports/Download/${user.Id}/DataSheet/${
                        report.Id
                      }`
                    "
                    >Species Datasheet</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
import MainNav from "@/components/MainNav.vue";

export default {
  name: "ReportHistory",
  components: {
    Footer,
    MainNav
  },
  mounted() {
    this.$store.dispatch("getUserReports");
  },
  computed: {
    reports() {
      return this.$store.getters.userReports;
    },
    inProgressReports() {
      return this.$store.getters.userReportsInProgress;
    },
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    reportCreatedSuccess() {
      return this.$route.query.success;
    }
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_BASE_URL
    };
  }
};
</script>
